var exports = {
  "WB": "FavoritesWelcomeSection.module__welcomeSection___enBIYW",
  "r2": "FavoritesWelcomeSection.module__iconSection___enBIYW",
  "P0": "FavoritesWelcomeSection.module__iconWrapper___enBIYW",
  "Kk": "FavoritesWelcomeSection.module__icon___enBIYW",
  "Jo": "FavoritesWelcomeSection.module__contentSection___enBIYW",
  "R_": "FavoritesWelcomeSection.module__heading___enBIYW",
  "h_": "FavoritesWelcomeSection.module__description___enBIYW",
  "uN": "FavoritesWelcomeSection.module__tip___enBIYW",
  "A2": "FavoritesWelcomeSection.module__actionSection___enBIYW",
};

module.exports = exports;
